// noinspection DuplicatedCode

import React, { useEffect, useRef, useState } from "react";
import { UndoOutlined } from "@ant-design/icons";
import { Button, DatePicker, Modal, Radio, Select, Space, Table } from "antd";
import SearchArea from "../../components/moleculas/SearchArea";
import SectionTitleArea from "../../components/moleculas/SectionTitleArea";
import ImgCamera from "../../assets/images/icon_video_24.svg";
import ImgNew from "../../assets/images/icon_notification_16.svg";
import Styles from "./Styles";
import PopEventStatus from "./PopEventStatus";
import {
  apiGet,
  apiGetDevice,
  apiGetEvent,
  apiGetEventAction,
  apiGetServiceCode,
  apiGetSitesComp,
  apiGetZonesDrop,
} from "../../api/api";
import { getGlobalSessionParam, isEmpty, setGlobalSessionParam } from "../../utils/comm";
import Moment from "react-moment";
import moment from "moment";
import { useLocation } from "react-router-dom";

const { Option } = Select;
const { Column } = Table;

const options = [
  { label: "1일", value: "days" },
  { label: "1주일", value: "weeks" },
  { label: "1개월", value: "months" },
  { label: "1년", value: "years" },
];

let siteId = null;
let codeNm = null;
let evtZnNm = null;
let devId = null;
let svcCd = null;
let periodSet = "days";
let startDtSet = moment();
let endDtSet = moment();
let serviceCd = [];

function ManageEvents() {
  const location = useLocation();
  // Parameter Save
  let defaultValue = {
    siteId: !isEmpty(getGlobalSessionParam("siteId")) ? getGlobalSessionParam("siteId") : null,
    svcCd: !isEmpty(getGlobalSessionParam("svcCd")) ? getGlobalSessionParam("svcCd") : null,
  };

  const StatusOptions = {
    SITE: "SITE",
    SVC: "SVC",
  };

  const initStatus = useRef(
    new Map([
      [StatusOptions.SITE, false],
      [StatusOptions.SVC, false],
    ])
  );

  if (!isEmpty(defaultValue.siteId)) {
    siteId = Number(defaultValue.siteId);
    svcCd = defaultValue.svcCd;
  }

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedCheckOption, setSelectedCheckOption] = useState(null);
  const [period, setPeriod] = useState(periodSet);
  const [startDt, setStartDt] = useState(startDtSet);
  const [endDt, setEndDt] = useState(endDtSet);
  const [zoneData, setZoneData] = useState([]);
  const [deviceData, setDeviceData] = useState([]);
  const [eventData, setEventData] = useState([]);
  const [mediaData, setMediaData] = useState([{ serialNo: null, znNm: null, updateDt: null, fileNm: null }]);
  const [sitesData, setSitesData] = useState();
  const [serviceData, setServiceData] = useState([]);
  const [masterCdData, setMasterCdData] = useState([]);
  const [siteForm, setSiteForm] = useState(null);
  const [eventForm, setEventForm] = useState(null);
  const [zoneForm, setZoneForm] = useState(null);
  const [deviceForm, setDeviceForm] = useState(null);

  useEffect(() => {
    apiGetSitesCompCall().then();
  }, []);

  useEffect(() => {
    getEventCdList(selectedCheckOption);
  }, [selectedCheckOption]);

  useEffect(() => {
    if (sitesData) {
      if (!initStatus.current.get(StatusOptions.SITE)) {
        initStatus.current = new Map(initStatus.current).set(StatusOptions.SITE, true);
        if (!initStatus.current.get(StatusOptions.SVC) && isEmpty(defaultValue.svcCd)) {
          initStatus.current = new Map(initStatus.current).set(StatusOptions.SVC, true);
        }

        if (!isEmpty(defaultValue.siteId)) {
          siteId = Number(defaultValue.siteId);
          setSiteForm(defaultValue.siteId);
          apiGetServiceCodeCall(defaultValue.svcCd).then();
          getEventCdList(defaultValue.svcCd, defaultValue.codeNm);
          apiGetZonesDropCall(defaultValue.svcCd).then();
          apiGetDeviceCall(defaultValue.svcCd).then();
          apiGetEventCallParam().then();
        }
      }
    }
  }, [sitesData]);

  const disabledDate = (current) => {
    return current > moment().endOf("day") || current < moment().subtract(10, "years");
  };

  // 사업장 드롭박스
  const apiGetSitesCompCall = async () => {
    const model = {
      compId: sessionStorage.getItem("compId"),
      userId: sessionStorage.getItem("userId"),
    };

    try {
      const response = await apiGetSitesComp(model);

      if (response.data.code === 0) {
        setSitesData([...response.data.data]);
      } else {
        setSitesData([]);
      }
    } catch (e) {
      setSitesData([]);
    }
  };

  // 입력폼
  function changeSite(value) {
    siteId = value;
    setSiteForm(value);
    setSelectedCheckOption(null);
    setZoneForm(null);
    setZoneData([]);
    setDeviceForm(null);
    setDeviceData([]);

    if (!isEmpty(String(value))) {
      apiGetServiceCodeCall(null).then(() => {
        apiGetEventSite().then();
      });
    } else {
      setServiceData([]);
      setEventData([]);
      setZoneData([]);
      setDeviceData([]);
    }

    const modelParam = {
      siteId: value,
      svcCd: null,
    };

    setGlobalSessionParam(modelParam);
  }

  // 서비스 드롭박스
  const apiGetServiceCodeCall = async (svcCd) => {
    const model = {
      siteId: siteId,
      userId: sessionStorage.getItem("userId"),
    };

    try {
      const response = await apiGetServiceCode(model);

      if (response.data.code === 0) {
        setServiceData(response.data.data);

        apiGetZonesDropCall(null).then();
        apiGetDeviceCall(null).then();
        apiGetEventCall(false).then();
      } else {
        setServiceData([]);
      }
    } catch (e) {
      setServiceData([]);
    } finally {
      if (!initStatus.current.get(StatusOptions.SVC)) {
        initStatus.current = new Map(initStatus.current).set(StatusOptions.SVC, true);

        setSelectedCheckOption(defaultValue.svcCd);
      }
    }
  };

  // 구역 드롭박스
  const apiGetZonesDropCall = async (svc) => {
    let svcCd = "";

    if (!isEmpty(svc)) {
      svcCd = svc;
    }

    const model = {
      siteId: isEmpty(siteId) ? siteForm : siteId,
      svcCd: svcCd,
    };

    try {
      const response = await apiGetZonesDrop(model);

      setZoneForm(null);
      setZoneData([]);
      if (response.data.code === 0) {
        setZoneData([...response.data.data]);
      }
    } catch (e) {}
  };

  // 디바이스 드롭박스
  const apiGetDeviceCall = async (svc) => {
    let svcCd = "";

    if (!isEmpty(svc)) {
      svcCd = svc;
    }

    const model = {
      siteId: isEmpty(siteId) ? siteForm : siteId,
      svcCd: svcCd,
    };

    try {
      const response = await apiGetDevice(model);

      setDeviceForm(null);
      setDeviceData([]);
      if (response.data.code === 0) {
        setDeviceData([...response.data.data]);
      }
    } catch (e) {}
  };

  // [SVC-0104014040] 서비스별 이벤트 코드 조회
  const getEventCdList = (svcCd, cdName) => {
    let catCdList = svcCd ? svcCd.toString() : null;

    apiGet(`Service/event`, {
      params: {
        catCdList: catCdList,
      },
    })
      .then((response) => {
        if (response.data.code === 0) {
          const data = response.data.data.filter((item) => item.evtCd != null);
          let result = [];
          if (data != null && data.length > 0) {
            data.forEach((item, index) => {
              result.push({
                code: item.evtCd,
                codeNm: item.evtNm,
                catCd: item.catCd,
                catNm: null,
              });
            });
          }
          setMasterCdData(result);
        } else {
          setMasterCdData([]);
        }
      })
      .catch(() => {
        setMasterCdData([]);
      });
  };

  const datePickerErrModal = () => {
    Modal.info({
      title: "정보 없음",
      icon: null,
      content: "날짜를 입력해주세요",
      okText: "확인",
      centered: true,
      onOk() {},
    });
  };

  // 이벤트 조회
  const apiGetEventSite = async () => {
    if (!startDt || !endDt) {
      datePickerErrModal();
      return;
    }

    const model = {
      siteId: siteId,
      startDt: startDt.format("YYYY-MM-DD"),
      endDt: endDt.format("YYYY-MM-DD"),
      codeNm: eventForm,
      evtZnNm: "",
      devId: "",
      svcCd: "",
      sort: "1",
    };

    try {
      const response = await apiGetEvent(model);

      if (response.data.code === 0) {
        setEventData([...response.data.data]);
      } else {
        setEventData([]);
      }
    } catch (e) {
      setEventData([]);
    }
  };

  // 이벤트 조회
  const apiGetEventCall = async (form) => {
    if (!startDt || !endDt) {
      datePickerErrModal();
      return;
    }

    let svcCd = "";

    const model = {
      siteId: form ? siteForm : siteId,
      startDt: startDt.format("YYYY-MM-DD"),
      endDt: endDt.format("YYYY-MM-DD"),
      codeNm: eventForm,
      evtZnNm: zoneForm,
      devId: deviceForm,
      svcCd: svcCd,
      sort: "1",
    };

    try {
      const response = await apiGetEvent(model);
      if (response.data.code === 0) {
        setEventData([...response.data.data]);
      } else {
        setEventData([]);
      }
    } catch (e) {
      setEventData([]);
    }
  };

  // 이벤트 조회
  const apiGetEventCallParam = async () => {
    if (!startDt || !endDt) {
      datePickerErrModal();
      return;
    }
    let svcCd = "";

    const model = {
      siteId: defaultValue.siteId,
      startDt: startDtSet.format("YYYY-MM-DD"),
      endDt: endDtSet.format("YYYY-MM-DD"),
      codeNm: null,
      evtZnNm: null,
      devId: null,
      svcCdList: svcCd,
      sort: "1",
    };

    try {
      const response = await apiGetEvent(model);

      if (response.data.code === 0) {
        setEventData([...response.data.data]);
      } else {
        setEventData([]);
      }
    } catch (e) {
      setEventData([]);
    }
  };

  // 디바이스 카메라 조회
  const apiGetEventActionCall = async (evtId) => {
    const model = {
      siteId: defaultValue.siteId,
      evtId: evtId,
    };

    try {
      const response = await apiGetEventAction(model);

      if (response.data.code === 0 || response.data.code === 10) {
        if (isEmpty(response.data.data)) {
          Modal.info({
            title: "상태확인",
            icon: null,
            content: "조회된 결과가 없습니다.",
            okText: "확인",
            centered: true,
            onOk() {},
          });
        } else {
          setMediaData([...response.data.data]);
          setIsModalVisible(true);
          apiGetEventCall(true).then();
        }
      }
    } catch (e) {}
  };

  const onChangeRadio = (e) => {
    setPeriod(e.target.value);
    setStartDt(moment().subtract(1, e.target.value).add(1, "days"));
    setEndDt(moment());
  };

  const serviceHandleChange = (value) => {
    setSelectedCheckOption(value);

    const modelParam = {
      siteId: siteId,
      svcCd: value,
    };

    setGlobalSessionParam(modelParam);
  };

  const handlePeriod = (startDt, endDt) => {
    if (startDt && endDt && endDt.format("YYYY-MM-DD") === moment().format("YYYY-MM-DD")) {
      if (startDt.format("YYYY-MM-DD") === moment().format("YYYY-MM-DD")) {
        setPeriod("days");
      } else if (startDt.format("YYYY-MM-DD") === moment().subtract(1, "weeks").add(1, "days").format("YYYY-MM-DD")) {
        setPeriod("weeks");
      } else if (startDt.format("YYYY-MM-DD") === moment().subtract(1, "months").add(1, "days").format("YYYY-MM-DD")) {
        setPeriod("months");
      } else if (startDt.format("YYYY-MM-DD") === moment().subtract(1, "years").add(1, "days").format("YYYY-MM-DD")) {
        setPeriod("years");
      } else {
        setPeriod(null);
      }
    } else {
      setPeriod(null);
    }
  };

  return (
    <Styles className='has-table-resize'>
      <h1 className='page-tit'>이벤트 관리</h1>
      <div className={"rpc-head-space rpc-pc"}>
        <SearchArea
          leftExtra={
            <Space size={[12, "small"]}>
              <div className='condition-item'>
                <label htmlFor='s1'>사업장</label>
                <Select
                  style={{ minWidth: 148 }}
                  id='s1'
                  placeholder='선택'
                  allowClear
                  showArrow={true}
                  showSearch={false}
                  value={siteForm}
                  onChange={changeSite}
                  options={
                    sitesData &&
                    sitesData.map((values, index) => ({
                      key: "pc-site-" + index,
                      value: values.siteId,
                      label: values.siteNm,
                    }))
                  }
                />
              </div>
              <div className='condition-item'>
                <label htmlFor='s2'>서비스</label>
                <Select
                  style={{ width: 230 }}
                  id='s2'
                  onChange={serviceHandleChange}
                  placeholder='선택'
                  allowClear
                  showArrow={true}
                  showSearch={false}
                  value={selectedCheckOption}
                  options={serviceData.map((values, index) => ({
                    key: "pc-svc-" + index,
                    value: values.catCd,
                    label: values.catNm,
                  }))}
                />
              </div>
            </Space>
          }
        />
        <SearchArea
          leftExtra={
            <Space>
              <Radio.Group
                options={options}
                onChange={onChangeRadio}
                value={period}
                optionType='button'
                buttonStyle='solid'
              />
              <Space>
                <DatePicker
                  format={["YYYY-MM-DD", "YYYYMMDD", "YYYY.MM.DD"]}
                  value={startDt}
                  onChange={(date) => {
                    setStartDt(date);
                    handlePeriod(date, endDt);
                  }}
                  disabledDate={disabledDate}
                />{" "}
                ~
                <DatePicker
                  format={["YYYY-MM-DD", "YYYYMMDD", "YYYY.MM.DD"]}
                  value={endDt}
                  onChange={(date) => {
                    setEndDt(date);
                    handlePeriod(startDt, date);
                  }}
                  disabledDate={disabledDate}
                />
              </Space>
              <Space>
                <Select
                  dropdownMatchSelectWidth={false}
                  style={{ minWidth: "150px" }}
                  placeholder={"감지 이벤트"}
                  allowClear
                  showArrow={true}
                  showSearch={false}
                  value={eventForm}
                  onChange={(value) => setEventForm(value)}
                  options={masterCdData.map((values, index) => ({
                    key: index,
                    value: values.code,
                    label: values.codeNm,
                  }))}
                />
              </Space>
              <Space>
                <Select
                  dropdownMatchSelectWidth={false}
                  style={{ minWidth: "150px" }}
                  placeholder={"구역"}
                  allowClear
                  showArrow={true}
                  showSearch={false}
                  value={zoneForm}
                  onChange={(value) => setZoneForm(value)}
                  options={zoneData.map((values, index) => ({
                    key: index,
                    value: values.znId,
                    label: values.znNm,
                  }))}
                />
                <Select
                  dropdownMatchSelectWidth={false}
                  style={{ minWidth: "150px" }}
                  placeholder={"디바이스"}
                  allowClear
                  showArrow={true}
                  showSearch={false}
                  value={deviceForm}
                  onChange={(value) => setDeviceForm(value)}
                  options={deviceData.map((values, index) => ({
                    key: index,
                    value: values.serialNo,
                    label: values.serialNo,
                  }))}
                />
              </Space>
            </Space>
          }
          rightExtra={
            <Space>
              <Button type='primary' className='btn-wide' onClick={() => apiGetEventCall(true)}>
                조회
              </Button>
            </Space>
          }
        />
        <SectionTitleArea
          title='이벤트 알림 내역'
          depth='depth2'
          rightExtra={<Button size='small' icon={<UndoOutlined />} onClick={() => apiGetEventCall(true)} />}
        />
      </div>

      <div className={"rpc-head-space rpc-mobile"}>
        <SectionTitleArea
          title='이벤트 알림 내역'
          depth='depth2'
          rightExtra={<Button size='small' icon={<UndoOutlined />} onClick={() => apiGetEventCall(true)} />}
        />
        <SearchArea
          leftExtra={
            <Space className={"rpc-head-container"} size={[12, "small"]}>
              <div className='condition-item'>
                <label htmlFor='s1'>사업장</label>
                <Select
                  style={{ minWidth: 148 }}
                  id='s1'
                  placeholder='선택'
                  allowClear
                  showArrow={true}
                  showSearch={false}
                  // defaultValue={siteId}
                  value={siteForm}
                  onChange={changeSite}
                >
                  {sitesData &&
                    sitesData.map((values, index) => (
                      <Option key={index} value={values.siteId}>
                        {values.siteNm}
                      </Option>
                    ))}
                </Select>
              </div>
              <div className='rpc-head-item condition-item'>
                <label htmlFor='s2'>서비스</label>
                <Select
                  id='s2'
                  onChange={serviceHandleChange}
                  placeholder='선택'
                  allowClear
                  showArrow={true}
                  showSearch={false}
                  value={selectedCheckOption}
                >
                  {serviceData.map((values, index) => (
                    <Option key={index} value={values.catCd}>
                      {values.catNm}
                    </Option>
                  ))}
                </Select>
              </div>
              <Radio.Group
                className={"rpc-head-inline"}
                options={options}
                onChange={onChangeRadio}
                value={period}
                optionType='button'
                buttonStyle='solid'
              />
              <Space className={"rpc-head-inline"}>
                <DatePicker
                  format={["YYYY-MM-DD", "YYYYMMDD", "YYYY.MM.DD"]}
                  value={startDt}
                  onChange={(date) => {
                    setStartDt(date);
                    handlePeriod(date, endDt);
                  }}
                  disabledDate={disabledDate}
                  // allowClear={false}
                />{" "}
                ~
                <DatePicker
                  format={["YYYY-MM-DD", "YYYYMMDD", "YYYY.MM.DD"]}
                  value={endDt}
                  onChange={(date) => {
                    setEndDt(date);
                    handlePeriod(startDt, date);
                  }}
                  disabledDate={disabledDate}
                  // allowClear={false}
                />
              </Space>
              <Space className={"rpc-head-item"}>
                <Select
                  dropdownMatchSelectWidth={false}
                  style={{ width: "100%" }}
                  placeholder={"감지 이벤트"}
                  allowClear
                  showArrow={true}
                  showSearch={false}
                  value={eventForm}
                  onChange={(value) => setEventForm(value)}
                >
                  {masterCdData.map((values, index) => (
                    <Option key={index} value={values.code}>
                      {values.codeNm}
                    </Option>
                  ))}
                </Select>
                <Select
                  dropdownMatchSelectWidth={false}
                  style={{ width: "100%" }}
                  placeholder={"구역"}
                  allowClear
                  showArrow={true}
                  showSearch={false}
                  value={zoneForm}
                  onChange={(value) => setZoneForm(value)}
                >
                  {zoneData.map((values, index) => (
                    <Option key={index} value={values.znId}>
                      {values.znNm}
                    </Option>
                  ))}
                </Select>
                <Select
                  dropdownMatchSelectWidth={false}
                  style={{ width: "100%" }}
                  placeholder={"디바이스"}
                  allowClear
                  showArrow={true}
                  showSearch={false}
                  value={deviceForm}
                  onChange={(value) => setDeviceForm(value)}
                >
                  {deviceData.map((values, index) => (
                    <Option key={index} value={values.devId}>
                      {values.serialNo}
                    </Option>
                  ))}
                </Select>
              </Space>
            </Space>
          }
          rightExtra={
            <Space>
              <Button type='primary' className='btn-wide' onClick={() => apiGetEventCall(true)}>
                조회
              </Button>
            </Space>
          }
        />
      </div>

      <div className='tbl-resize-wrapper' style={{ minHeight: 300 }}>
        <Table
          dataSource={eventData}
          pagination={false}
          bordered
          showSorterTooltip={false}
          scroll={{ x: 900 }}
          rowClassName={(record) => (record.readYn === "N" ? "row-new" : "")}
        >
          <Column
            title='No'
            dataIndex='no'
            key='1'
            width='50px'
            render={(value, record, index) => (record.readYn === "N" ? <img src={ImgNew} alt='new' /> : index + 1)}
          />
          <Column
            title='일시'
            dataIndex='createDt'
            key='2'
            sorter={(a, b) => String(a.createDt).localeCompare(String(b.createDt))}
            defaultSortOrder='descend'
            render={(value) => <Moment date={value} format={"YYYY-MM-DD HH:mm:ss"} />}
          />
          <Column
            title='서비스'
            dataIndex='catNm'
            key='3'
            sorter={(a, b) => String(a.catNm).localeCompare(String(b.catNm))}
          />
          <Column
            title='감지 이벤트'
            dataIndex='evtTp'
            key='4'
            sorter={(a, b) => String(a.evtTp).localeCompare(String(b.evtTp))}
            render={(value) => masterCdData.map((item) => (item.code === value ? item.codeNm : ""))}
          />
          <Column
            title='구역'
            dataIndex='evtZnNm'
            key='6'
            sorter={(a, b) => String(a.evtZnNm).localeCompare(String(b.evtZnNm))}
          />
          <Column
            title='장비'
            dataIndex='equSn'
            key='7'
            sorter={(a, b) => String(a.equSn).localeCompare(String(b.equSn))}
            render={(value, record, index) => (isEmpty(record.equNo) ? value : value + "(" + record.equNo + ")")}
          />
          <Column
            title='감지 디바이스'
            dataIndex='serialNo'
            key='8'
            sorter={(a, b) => String(a.serialNo).localeCompare(String(b.serialNo))}
          />
          <Column
            title='이벤트 상황 조회'
            key='9'
            width='130'
            render={(value, record, index) => (
              <Button
                onClick={() => {
                  apiGetEventActionCall(record.evtId).then();
                }}
                style={{ color: "#1A65BC", fontSize: "20px" }}
                className='btn-ico-only'
              >
                <img src={ImgCamera} alt='이벤트상황' />
              </Button>
            )}
          />
        </Table>
      </div>

      <Modal
        title='이벤트 상황 조회'
        visible={isModalVisible}
        onOk={() => setIsModalVisible(false)}
        onCancel={() => setIsModalVisible(false)}
        okButtonProps={{ style: { display: "none" } }}
        cancelButtonProps={{ style: { display: "none" } }}
        getContainer={false}
        width={"fit-content"}
        footer={null}
        bodyStyle={{ paddingBottom: "35px" }}
        // 스와이퍼가 있는 모달에서 마우스로 슬라이딩시 터치 미스로 딤처리 영역 클릭시 팝업이 닫혀버리는 현상 방지하기위해 지정 maskClosable
        maskClosable={false}
        className={"eventModal"}
      >
        <PopEventStatus mediaData={mediaData} evtCdData={masterCdData} />
      </Modal>
    </Styles>
  );
}

export default ManageEvents;
